import React from "react";
import Calendar from "../Calendar/Calendar";

export default function DateInput({
  label,
  value,
  setValue,
  setUIValue,
  validate,
}) {
  return (
    <Calendar
      value={value}
      setValue={(e) => {
        const date = new Date(e.target.value);
        let dateDD = date.getDate();
        let dateMM = date.getMonth() + 1;
        let dateYYYY = date.getFullYear();
        if (dateDD < 10) dateDD = "0" + dateDD;
        if (dateMM < 10) dateMM = "0" + dateMM;
        const today = `${dateYYYY}-${dateMM}-${dateDD}`;

        setValue(today);
        setUIValue(e.target.value);
      }}
      label={label}
      validate={validate}
    />
  );
}
